import { MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { RefObject } from 'react'
import { MetaPath } from 'util/metaPath'

import {
  ConsultaSeguimentoAplicacaoModel,
  ConsultaSeguimentoPergunta01Field,
  ConsultaSeguimentoPergunta02Field,
  ConsultaSeguimentoPergunta03Field,
  ConsultaSeguimentoPergunta04Field,
  ConsultaSeguimentoPergunta05Field,
  ConsultaSeguimentoPergunta06Field,
  ConsultaSeguimentoPergunta07Field,
  ConsultaSeguimentoPergunta08Field,
  ConsultaSeguimentoPergunta09Field,
  ConsultaSeguimentoPergunta10Field,
  ConsultaSeguimentoPergunta11Field,
  ConsultaSeguimentoPergunta12Field,
  ConsultaSeguimentoPergunta13Field,
  ConsultaSeguimentoPergunta14Field,
  ConsultaSeguimentoPergunta15Field,
  ConsultaSeguimentoPergunta16Field,
  ConsultaSeguimentoPergunta17Field,
  ConsultaSeguimentoPergunta18Field,
  ConsultaSeguimentoPergunta19Field,
  ConsultaSeguimentoPergunta20Field,
  convertConsultaSeguimentoPergunta01ToInput,
  convertConsultaSeguimentoPergunta02ToInput,
  convertConsultaSeguimentoPergunta03ToInput,
  convertConsultaSeguimentoPergunta04ToInput,
  convertConsultaSeguimentoPergunta05ToInput,
  convertConsultaSeguimentoPergunta06ToInput,
  convertConsultaSeguimentoPergunta07ToInput,
  convertConsultaSeguimentoPergunta08ToInput,
  convertConsultaSeguimentoPergunta09ToInput,
  convertConsultaSeguimentoPergunta10ToInput,
  convertConsultaSeguimentoPergunta11ToInput,
  convertConsultaSeguimentoPergunta12ToInput,
  convertConsultaSeguimentoPergunta13ToInput,
  convertConsultaSeguimentoPergunta14ToInput,
  convertConsultaSeguimentoPergunta15ToInput,
  convertConsultaSeguimentoPergunta16ToInput,
  convertConsultaSeguimentoPergunta17ToInput,
  convertConsultaSeguimentoPergunta18ToInput,
  convertConsultaSeguimentoPergunta19ToInput,
  convertConsultaSeguimentoPergunta20ToInput,
  prunePergunta01,
  prunePergunta02,
  prunePergunta03,
  prunePergunta04,
  prunePergunta05,
  prunePergunta06,
  prunePergunta07,
  prunePergunta08,
  prunePergunta09,
  prunePergunta10,
  prunePergunta11,
  prunePergunta12,
  prunePergunta13,
  prunePergunta14,
  prunePergunta15,
  prunePergunta16,
  prunePergunta17,
  prunePergunta18,
  prunePergunta19,
  prunePergunta20,
} from '.'
import { MChatPerguntaPrincipal } from './model-consultaSeguimento'

type ConsultaSeguimentoPerguntasMapModel = {
  [Key in MChatPerguntaPrincipal]: {
    Field: React.ComponentType<{
      name: MetaPath<NonNullable<ConsultaSeguimentoAplicacaoModel[Key]>>
      perguntasSelecionadas: MChatPerguntaPrincipal[]
      goNextButtonRef: RefObject<HTMLButtonElement>
      containerRef: RefObject<HTMLDivElement>
    }>
    convertToInput: (resposta: NonNullable<ConsultaSeguimentoAplicacaoModel[Key]>) => MChatRfPerguntaRespostaInput[]
    pruneUnusedBranches: (
      resposta: NonNullable<ConsultaSeguimentoAplicacaoModel[Key]>
    ) => ConsultaSeguimentoAplicacaoModel[Key]
  }
}

export const CONSULTA_SEGUIMENTO_PERGUNTAS: ConsultaSeguimentoPerguntasMapModel = {
  PERGUNTA_01: {
    Field: ConsultaSeguimentoPergunta01Field,
    convertToInput: convertConsultaSeguimentoPergunta01ToInput,
    pruneUnusedBranches: prunePergunta01,
  },
  PERGUNTA_02: {
    Field: ConsultaSeguimentoPergunta02Field,
    convertToInput: convertConsultaSeguimentoPergunta02ToInput,
    pruneUnusedBranches: prunePergunta02,
  },
  PERGUNTA_03: {
    Field: ConsultaSeguimentoPergunta03Field,
    convertToInput: convertConsultaSeguimentoPergunta03ToInput,
    pruneUnusedBranches: prunePergunta03,
  },
  PERGUNTA_04: {
    Field: ConsultaSeguimentoPergunta04Field,
    convertToInput: convertConsultaSeguimentoPergunta04ToInput,
    pruneUnusedBranches: prunePergunta04,
  },
  PERGUNTA_05: {
    Field: ConsultaSeguimentoPergunta05Field,
    convertToInput: convertConsultaSeguimentoPergunta05ToInput,
    pruneUnusedBranches: prunePergunta05,
  },
  PERGUNTA_06: {
    Field: ConsultaSeguimentoPergunta06Field,
    convertToInput: convertConsultaSeguimentoPergunta06ToInput,
    pruneUnusedBranches: prunePergunta06,
  },
  PERGUNTA_07: {
    Field: ConsultaSeguimentoPergunta07Field,
    convertToInput: convertConsultaSeguimentoPergunta07ToInput,
    pruneUnusedBranches: prunePergunta07,
  },
  PERGUNTA_08: {
    Field: ConsultaSeguimentoPergunta08Field,
    convertToInput: convertConsultaSeguimentoPergunta08ToInput,
    pruneUnusedBranches: prunePergunta08,
  },
  PERGUNTA_09: {
    Field: ConsultaSeguimentoPergunta09Field,
    convertToInput: convertConsultaSeguimentoPergunta09ToInput,
    pruneUnusedBranches: prunePergunta09,
  },
  PERGUNTA_10: {
    Field: ConsultaSeguimentoPergunta10Field,
    convertToInput: convertConsultaSeguimentoPergunta10ToInput,
    pruneUnusedBranches: prunePergunta10,
  },
  PERGUNTA_11: {
    Field: ConsultaSeguimentoPergunta11Field,
    convertToInput: convertConsultaSeguimentoPergunta11ToInput,
    pruneUnusedBranches: prunePergunta11,
  },
  PERGUNTA_12: {
    Field: ConsultaSeguimentoPergunta12Field,
    convertToInput: convertConsultaSeguimentoPergunta12ToInput,
    pruneUnusedBranches: prunePergunta12,
  },
  PERGUNTA_13: {
    Field: ConsultaSeguimentoPergunta13Field,
    convertToInput: convertConsultaSeguimentoPergunta13ToInput,
    pruneUnusedBranches: prunePergunta13,
  },
  PERGUNTA_14: {
    Field: ConsultaSeguimentoPergunta14Field,
    convertToInput: convertConsultaSeguimentoPergunta14ToInput,
    pruneUnusedBranches: prunePergunta14,
  },
  PERGUNTA_15: {
    Field: ConsultaSeguimentoPergunta15Field,
    convertToInput: convertConsultaSeguimentoPergunta15ToInput,
    pruneUnusedBranches: prunePergunta15,
  },
  PERGUNTA_16: {
    Field: ConsultaSeguimentoPergunta16Field,
    convertToInput: convertConsultaSeguimentoPergunta16ToInput,
    pruneUnusedBranches: prunePergunta16,
  },
  PERGUNTA_17: {
    Field: ConsultaSeguimentoPergunta17Field,
    convertToInput: convertConsultaSeguimentoPergunta17ToInput,
    pruneUnusedBranches: prunePergunta17,
  },
  PERGUNTA_18: {
    Field: ConsultaSeguimentoPergunta18Field,
    convertToInput: convertConsultaSeguimentoPergunta18ToInput,
    pruneUnusedBranches: prunePergunta18,
  },
  PERGUNTA_19: {
    Field: ConsultaSeguimentoPergunta19Field,
    convertToInput: convertConsultaSeguimentoPergunta19ToInput,
    pruneUnusedBranches: prunePergunta19,
  },
  PERGUNTA_20: {
    Field: ConsultaSeguimentoPergunta20Field,
    convertToInput: convertConsultaSeguimentoPergunta20ToInput,
    pruneUnusedBranches: prunePergunta20,
  },
}
